module.exports = [
  {
    key: 0,
    label: "XP",
  },
  {
    key: 1,
    label: "Knowledge",
  },
  {
    key: 2,
    label: "Key",
  },
  {
    key: 3,
    label: "USD",
  },
  {
    key: 6,
    label: "Gold",
  },
];
